import React from "react";
import { Navigate } from "react-router-dom";

import { UserRole } from "entities/common";

import { RootStore } from "store";
import { useAppSelector } from "store/hooks";

import { PAGES } from "utils/links";

interface RequireAdminProps {
  children: React.ReactElement;
}

export const RequireAdmin: React.FC<RequireAdminProps> = ({ children }) => {
  const user = useAppSelector((state: RootStore) => state.auth.user);

  if (user?.role !== UserRole.ADMINISTRATOR) {
    return <Navigate to={PAGES.NOT_FOUND} replace />;
  }

  return children;
};
